import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ProductLabelsAPI from '../../api/productLabels';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { PRODUCT_LABEL_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getProductLabels(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getProductLabelsOnSidebar(_state) {
    return _state.records
      .filter(record => record.show_on_sidebar)
      .sort((a, b) => a.title.localeCompare(b.title));
  },
};

export const actions = {
  revalidate: async function revalidate({ commit }, { newKey }) {
    try {
      const isExistingKeyValid = await ProductLabelsAPI.validateCacheKey(newKey);
      if (!isExistingKeyValid) {
        const response = await ProductLabelsAPI.refetchAndCommit(newKey);
        commit(types.SET_PRODUCT_LABELS, response.data.payload);
      }
    } catch (error) {
      // Ignore error
    }
  },

  get: async function getProductLabels({ commit }) {
    commit(types.SET_PRODUCT_LABEL_UI_FLAG, { isFetching: true });
    try {
      const response = await ProductLabelsAPI.get(true);
      commit(types.SET_PRODUCT_LABELS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_PRODUCT_LABEL_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createProductLabels({ commit }, payload) {
    commit(types.SET_PRODUCT_LABEL_UI_FLAG, { isCreating: true });
    try {
      const response = await ProductLabelsAPI.create(payload);
      AnalyticsHelper.track(PRODUCT_LABEL_EVENTS.CREATE);
      commit(types.ADD_PRODUCT_LABEL, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_PRODUCT_LABEL_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateProductLabels({ commit }, { id, ...updateObj }) {
    commit(types.SET_PRODUCT_LABEL_UI_FLAG, { isUpdating: true });
    try {
      const response = await ProductLabelsAPI.update(id, updateObj);
      AnalyticsHelper.track(PRODUCT_LABEL_EVENTS.UPDATE);
      commit(types.EDIT_PRODUCT_LABEL, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PRODUCT_LABEL_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteProductLabels({ commit }, id) {
    commit(types.SET_PRODUCT_LABEL_UI_FLAG, { isDeleting: true });
    try {
      await ProductLabelsAPI.delete(id);
      AnalyticsHelper.track(PRODUCT_LABEL_EVENTS.DELETED);
      commit(types.DELETE_PRODUCT_LABEL, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PRODUCT_LABEL_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_PRODUCT_LABEL_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_PRODUCT_LABELS]: MutationHelpers.set,
  [types.ADD_PRODUCT_LABEL]: MutationHelpers.create,
  [types.EDIT_PRODUCT_LABEL]: MutationHelpers.update,
  [types.DELETE_PRODUCT_LABEL]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

